import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    constructor() { }

    private months:any = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

    public defaultProfileImageUrl = "https://static.wixstatic.com/media/54835c_e1669a3114f440bd8ea7d3f0d0745ceb~mv2.jpg";

    public friendlyRank(i){
        let abbr = "th";
        let rank = i + 1;
        let last = (rank % 10);
        if (last == 1){
            abbr = "st";
        } else if (last == 2){
            abbr = "nd";
        } else if (last == 3){
            abbr = "rd";
        }

        return rank + abbr;
    }

    public racerDivision(racer){
        // this will be used to calculate the racer's age & gender to apply them to the race's pre determined categories, ie M35-39
        let d = new Date();
        let rtn = "";
        if (racer.gender){
            rtn += racer.gender;
        }
        if (racer.yob){
            let y = "";
            if ((d.getFullYear() - racer.yob) < 20){
                y = "19-";
            } else if ((d.getFullYear() - racer.yob) < 30){
                y = "20-29";
            } else if ((d.getFullYear() - racer.yob) < 40){
                y = "30-39";
            } else if ((d.getFullYear() - racer.yob) < 50){
                y = "40-49";
            } else if ((d.getFullYear() - racer.yob) < 60){
                y = "50-59";
            } else {
                y = "60+";
            }
            rtn += y;
        }
        return rtn;
    }

    public racerTimeOnCourse(racer, raceProfile){
        if (!racer.laps){
            return 'error - to laps found';
        }
        let msOnCourse = 0;
        for (let l = 0; l < racer.laps.length; l++){
            if (racer.laps[l].completed){
                msOnCourse += racer.laps[l].lapDuration;
            } else {
                if (racer.laps[l].started){
                    // msOnCourse +=  Date.parse(new Date().toISOString()) - Date.parse(racer.laps[l].started.toISOString());
                    msOnCourse += raceProfile.timeElapsedMS;
                }
            }
        }
        if (msOnCourse == 0){
            return 'Runner Not Started';
        } else {
            return this.friendlyTimeDuration(msOnCourse, 'ms');
        }
    }

    public racerLapsCompleted(racer){
        let lapCount = 0;
        if (racer.laps) {
            for (let i = 0; i < racer.laps.length; i++) {
                if (racer.laps[i].started && racer.laps[i].completed) {
                    lapCount++;
                }
            }
        }

        return lapCount;
    }

    public friendlyTime = function(date, timezone: string = "America/Chicago"){
        if (!date){
            return "";
        }
        let d: any = {};
        if (timezone){
            date = new Date(date).toLocaleString("en-US", {timeZone: timezone});
        }
        d = new Date(date);
        let day:number = d.getDate();
        let y: number = day;
        let abbr:string = 'th';
        if (y > 30){
            y = y - 30
        } else if (y > 20){
            y = y - 20
        }
        if (y == 1){
            abbr = "st"
        } else if (y == 2){
            abbr = "nd"
        } else if (y == 3){
            abbr = "rd"
        }
        let hours:number = d.getHours();
        let ap:string = "AM";
        if (hours > 11){
            ap = "PM";
            hours = hours - 12;
        }
        if (hours == 0){ hours = 12; }
        let min = d.getMinutes();
        let sec = d.getSeconds();
        let minStr:string = (min < 10 ? "0"+min.toString() : min.toString());
        let secStr:string = (sec < 10 ? "0"+sec.toString() : sec.toString());
        let time:string = hours+":"+minStr+":"+secStr+" "+ap;

        return this.months[d.getMonth()]+" "+day+abbr+", "+time;
    };

    public FormatterTimeStampToDate = function(d){
        if (d){
            if (typeof d === "string") {
                if (d) {
                    // d = d.replace("T", " ").replace("Z", ""); // this was not applying timezone shift - using the date string with T and Z does apply the timezone shift.
                    let eDate = new Date(d);
                    return eDate.toLocaleString();
                }
            } else if (typeof d === "number"){
                let nDate = new Date(d);
                return nDate.toLocaleString();
            } else {
                // assume a date already
                return d.toLocaleString();
             }
        } else {
            return "";
        }
    };

    public getPrettyTime = function(time){
        if (time.length < 4) { time = "0" + time}
        let hours = Number(time.substring(0, 2));
        let min = time.substring(2, 4);
        let prettyTime = "";

        if (hours < 12){
            if (hours == 0){
                prettyTime = "12:" + min + "AM";
            } else {
                prettyTime = hours + ":" + min + "AM";
            }
        } else {
            if (hours == 12){
                prettyTime = "12:" + min + "AM";
            } else {
                prettyTime = (hours - 12) + ":" + min + "PM";
            }
        }
        return prettyTime;
    };
    public getFriendlyHours = function(hours){
        if (hours < 12){
            if (hours == 0){
                hours = "12AM";
            } else {
                hours = hours + "AM";
            }
        } else {
            if (hours == 12){
                hours = "12PM";
            } else {
                hours = (hours - 12) + "PM";
            }
        }
        return hours;
    };

    public friendlyTimeDuration = function(s:number, uom:string){
        if (isNaN(s)){
            return "0s"
        }
        if (!uom){
            s = s/1000;
        }
        if (uom == "ms"){
            s = s/1000;
        }

        let seconds:number = s%60;
        let minutes:number = (s/60)%60;
        let hours:number = (s/(60*60))%24;
        let days:number = (s/(60*60*24));
        let daysStr:string = "";
        if (days >= 1){
            daysStr = Math.floor(days)+"d ";
        }
        let hoursStr:string = "";
        if (hours >= 1){
            hoursStr = Math.floor(hours)+"h "
        }
        let minutesStr:string = "";
        if (minutes >= 1){
            if (minutes < 10 && hoursStr){
                minutesStr = Math.floor(minutes)+"m ";
            } else {
                minutesStr = Math.floor(minutes)+"m ";
            }
        }
        let secondsStr:string = "0s";
        if (seconds >= 1){
            if (seconds < 10 && minutesStr){
                secondsStr = Math.floor(seconds)+"s"
            } else {
                secondsStr = Math.floor(seconds)+"s"
            }
        }
        if (!minutesStr && !hoursStr && !daysStr){
            return secondsStr;
        } else if (!hoursStr && !daysStr){
            if (seconds > 0) {
                return minutesStr + secondsStr;
            } else {
                return minutesStr;
            }
        } else if (!daysStr){
            if (seconds > 0) {
                return hoursStr + minutesStr + secondsStr;
            } else {
                return hoursStr + minutesStr;
            }
        } else {
            if (seconds > 0){
                return daysStr + hoursStr + minutesStr + secondsStr;
            } else {
                return daysStr + hoursStr + minutesStr;
            }
        }
    };
}
